import { render, staticRenderFns } from "./SnSelector.vue?vue&type=template&id=38f3dc80&scoped=true&"
import script from "./SnSelector.vue?vue&type=script&lang=js&"
export * from "./SnSelector.vue?vue&type=script&lang=js&"
import style0 from "./SnSelector.vue?vue&type=style&index=0&id=38f3dc80&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3dc80",
  null
  
)

export default component.exports